import { IConfig } from './models';

export const configDesktop: IConfig = {
    hr: { mt: 48, mb: 48 },
    img: { mt: 48, mb: 48 },
    h1: { mt: 48, mb: 24, view: 'large' },
    h2: { mt: 48, mb: 24, view: 'medium' },
    h3: { mt: 32, mb: 24, view: 'small' },
    h4: { mt: 32, mb: 24 },
    h5: { mt: 32, mb: 24 },
    h6: { mt: 32, mb: 24 },
    blockquote: { pt: 48, pb: 36, mb: 32, mt: 32 },
};

export const configMobile: IConfig = {
    hr: { mt: 32, mb: 32 },
    img: { mt: 32, mb: 32 },
    h1: { mt: 32, mb: 16, view: 'medium' },
    h2: { mt: 32, mb: 16, view: 'small' },
    h3: { mt: 24, mb: 16, view: 'xsmall' },
    h4: { mt: 24, mb: 16 },
    h5: { mt: 24, mb: 16 },
    h6: { mt: 24, mb: 16 },
    blockquote: { pt: 24, pb: 12, mb: 24, mt: 24 },
};
